import './pricing.css';
import { CURSOS } from '../../config/cursos.js';
import { CERTIFICACIONES } from '../../config/certificaciones.js';

// Sección 05 — "Pricing · Una sola suscripción". Toggle Mensual/Anual que cambia
// precio + nota (con un "pop"), tarjeta liquid-glass con 9 beneficios. Fiel al
// .dc.html de Claude Design (misma copy, precios y lógica del componente DCLogic).

// LAS DOS CIFRAS SE CALCULAN, no se escriben. El renglón de cursos decía "40"
// a mano y el catálogo tiene hoy 40 — coincidía por suerte, no por construcción.
//
// Las horas: el video del catálogo son 55.7 h. Las "+100" salen de sumar lo que
// YA publica cada certificación en su propia página (40 h + 40 h + 26 h = 106),
// que es video MÁS el trabajo de proyecto que la ruta exige. Se redondea hacia
// abajo a la decena para que el "+" sea verdad y no al revés.
const HORAS = Math.floor(
  CERTIFICACIONES.reduce((n, c) => n + (parseInt(c.horas, 10) || 0), 0) / 10,
) * 10;

const FEATURES = [
  `${CURSOS.length} cursos de especialización`,
  `+${HORAS} horas de contenido`,
  'Sesiones en vivo con expertos Zenkai',
  'Asesorías en vivo',
  'Comunidad de ingenieros VIP',
  'Sistema de desarrollo personal',
  'Formatos editables',
];

// LAS CIFRAS, COMPROBADAS. El sitio anunciaba "equivale a pagar solo 8 meses" y
// "ahorra 4 meses", y ninguna de las dos salía: a $497 al mes, el año cuesta
// $5,964; el plan anual de $4,500 equivale a 9.05 meses y ahorra $1,464, que
// son 2.95 meses, no 4. Se exageraba el ahorro en un mes entero.
//
// Ahora se dice el ahorro en PESOS, que es exacto y no depende de redondear
// meses. El copy v2 traía este mismo cálculo y coincide.
const PLANS = {
  mensual: { price: '497', note: 'Facturación mensual · cambia a anual y ahorra $1,464 al año' },
  anual: { price: '375', note: 'A 12 meses sin intereses · $4,500 mxn al año' },
};

const CARD_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="2.5" y="5" width="19" height="14" rx="2.5" stroke="currentColor" stroke-width="1.7"/><path d="M2.5 9.5h19" stroke="currentColor" stroke-width="1.7"/><path d="M6 15h4" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>`;

const CHECK = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="9" fill="rgba(30,209,233,.16)"/><path d="M6 10.2l2.6 2.6L14 7.4" stroke="#1ED1E9" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
const ENSO_SM = `<svg viewBox="0 0 100 100" aria-hidden="true"><circle cx="50" cy="52" r="38" fill="none" stroke="currentColor" stroke-width="12" stroke-linecap="round" stroke-dasharray="205 300" transform="rotate(122 50 50)"/></svg>`;

function markup() {
  return `
  <div class="zk-pricing__glow" aria-hidden="true"></div>

  <div class="zk-pricing__head">
    <div class="zk-pricing__eyebrow" data-reveal style="color:#D4323C">${ENSO_SM}<span>Una sola suscripción</span></div>
    <h2 class="zk-pricing__title" data-reveal>Tu aumento anual cubre la inflación. Un ascenso cambia tu tabulador.</h2>
    <p class="zk-pricing__sub" data-reveal>Un cambio de puesto suele subir el sueldo entre 20 y 40%. Si hoy ganas $30,000 al mes, un 20% son $72,000 m&aacute;s al a&ntilde;o. Tu a&ntilde;o en Zenkai cuesta $4,500.</p>
  </div>

  <div class="zk-pricing__toggle" data-reveal>
    <div class="zk-pricing__seg" role="tablist" aria-label="Periodicidad de la suscripción">
      <button type="button" data-plan="mensual" role="tab" aria-selected="false">Mensual</button>
      <button type="button" data-plan="anual" class="is-active" role="tab" aria-selected="true">
        <span class="zk-pricing__pop" aria-hidden="true">★ Recomendado</span>
        Anual <span class="save">· ahorras $1,464</span>
      </button>
    </div>
  </div>

  <div class="zk-pricing__border" data-reveal>
    <div class="zk-pricing__card">
      <div class="zk-pricing__card-glow" aria-hidden="true"></div>
      <svg class="zk-pricing__enso" viewBox="0 0 200 200" aria-hidden="true">
        <defs><linearGradient id="pz-enso" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#D4323C"/><stop offset="1" stop-color="#B01F28"/></linearGradient></defs>
        <circle cx="100" cy="100" r="74" fill="none" stroke="url(#pz-enso)" stroke-width="17" stroke-linecap="round" stroke-dasharray="398 600" transform="rotate(150 100 100)"/>
        <circle cx="100" cy="100" r="60" fill="none" stroke="url(#pz-enso)" stroke-width="9" stroke-linecap="round" stroke-dasharray="300 600" transform="rotate(168 100 100)" opacity=".8"/>
      </svg>

      <div class="zk-pricing__pad">
        <div class="zk-pricing__plan">
          <span class="zk-pricing__plan-icon" style="color:#D4323C">${ENSO_SM}</span>
          <div>
            <div class="name">Sistema Zenkai · 12 meses</div>
            <div class="desc">Los 4 ejes, con acompañamiento cada dos semanas.</div>
          </div>
        </div>

        <div class="zk-pricing__price">
          <div class="zk-pricing__amount">
            <span class="cur">$</span><span class="num" data-price>${PLANS.anual.price}</span><span class="per">mxn/mes</span>
          </div>
          <!-- La nota inicial sale de PLANS, no escrita aparte. Estaba duplicada y al
                 corregir la aritmética en PLANS esta se quedó con el texto viejo: el
                 primer pintado decía "8 meses" y solo al tocar el interruptor
                 aparecía el dato bueno. -->
            <div class="zk-pricing__note" data-note>${PLANS.anual.note}</div>
        </div>

        <div class="zk-pricing__msi" data-msi>${CARD_SVG}<span>Hasta <b>12 Meses Sin Intereses</b> con tarjetas participantes</span></div>

        <div class="zk-pricing__cta">
          <button type="button" class="zk-pricing__buy">Únete a Zenkai</button>
          <span class="zk-pricing__guarantee">Sin permanencia · cancela cuando quieras</span>
        </div>
      </div>

      <div class="zk-pricing__features">
        <div class="label" data-reveal>Qué incluye la plataforma</div>
        <div class="zk-pricing__grid">
          ${FEATURES.map((f) => `<div class="zk-pricing__feat" data-reveal>${CHECK}<span>${f}</span></div>`).join('')}
        </div>
      </div>
    </div>
  </div>`;
}

/**
 * Monta la sección de Pricing dentro de `mount`.
 * @returns {HTMLElement} la <section> montada.
 */
export function mountPricing(mount) {
  const section = document.createElement('section');
  section.className = 'zk-pricing';
  section.id = 'pricing';
  section.dataset.plan = 'anual';          // arranca en Anual (el plan destacado)
  section.setAttribute('aria-label', 'Suscripción a Zenkai');
  section.innerHTML = markup();
  (mount || document.body).appendChild(section);

  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Toggle mensual/anual.
  const buttons = [...section.querySelectorAll('.zk-pricing__seg button')];
  const amount = section.querySelector('.zk-pricing__amount');
  const priceEl = section.querySelector('[data-price]');
  const noteEl = section.querySelector('[data-note]');
  const setPlan = (plan) => {
    const p = PLANS[plan];
    if (!p || priceEl.textContent === p.price && buttons.find((b) => b.dataset.plan === plan).classList.contains('is-active')) return;
    priceEl.textContent = p.price;
    noteEl.textContent = p.note;
    section.dataset.plan = plan;            // muestra/oculta el chip de MSI (solo anual)
    buttons.forEach((b) => {
      const on = b.dataset.plan === plan;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', String(on));
    });
    if (!reduced) {
      // Re-dispara el "pop" del precio y la nota.
      [amount, noteEl].forEach((el) => {
        el.classList.remove('is-changing');
        void el.offsetWidth;
        el.classList.add('is-changing');
      });
    }
  };
  buttons.forEach((b) => b.addEventListener('click', () => setPlan(b.dataset.plan)));

  // Entrada escalonada.
  const revealEls = [...section.querySelectorAll('[data-reveal]')];
  if (reduced) {
    section.classList.add('is-in');
    return section;
  }
  section.classList.add('is-fx');
  // Mismo caso que testimonios: 14 elementos a 55 ms daban 700 de escalonado,
  // contra un tope de 500. A 32 el último entra a 416.
  revealEls.forEach((el, i) => { el.style.transitionDelay = `${Math.min(i * 32, 416)}ms`; });
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { section.classList.add('is-in'); io.disconnect(); } });
    }, { threshold: 0.12 });
    io.observe(section);
  } else {
    section.classList.add('is-in');
  }

  return section;
}
